import { Modal, Stack, Text } from "@mantine/core"
import { Button, Select } from "@tfg/ui"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { AdminResponses } from "@tfg/types/endpoints/admin"

import { useUpdateOrganizationMutation } from "./hooks"

interface Props {
  opened: boolean
  data: { label: string; value: string }[]
  organization: AdminResponses.Organization
  onClose: () => void
  planKey: keyof AdminResponses.Organization["settings"]
}

export const ChangePlanModal = ({
  opened,
  data,
  organization,
  onClose,
  planKey,
}: Props) => {
  const {
    mutate: updateOrganization,
    isLoading,
    isError,
  } = useUpdateOrganizationMutation(organization.id.toString(), {
    onSuccess: onClose,
  })
  const { t } = useTranslation("admin")
  const [plan, setPlan] = useState<
    AdminResponses.Organization["settings"][typeof planKey]
  >(organization.settings[planKey])

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={t("plan.customFieldsPlan.label")}
    >
      <Stack>
        <Select
          data={data}
          placeholder="New plan"
          value={plan}
          onChange={(newPlan: string | null) =>
            newPlan &&
            setPlan(
              newPlan as AdminResponses.Organization["settings"][typeof planKey]
            )
          }
        />
        {isError && (
          <Text fz="sm" c="red">
            An error occurred. Please try again later
          </Text>
        )}
        <Button
          loading={isLoading}
          onClick={() =>
            updateOrganization(Object.fromEntries([[planKey, plan]]))
          }
        >
          Change plan
        </Button>
      </Stack>
    </Modal>
  )
}
